import ShipTypeRange from "./ShipTypeRange"
import CarbonCoefType from "./CarbonCoefType"

class ShipType {
    public id: string = ""
    public name: string = ""
    public code: string = ""
    public ranges: Array<ShipTypeRange> = new Array<ShipTypeRange>()
    public c: number=0
    public a: number=0
    public C: number=0
    public A: number=0
    public D: number=0
    public F: number=0
    public useGT: boolean=true

    public cb_ref_10000: number = 0
    public cb_ref_25000: number = 0
    public cb_ref_55000: number = 0
    public cb_ref_75000: number = 0
    public cb_ref_MAX: number = 0

    public design_coef_alfa: number = 0
    public design_coef_beta: number = 0
    public design_coef_delta: number = 0
    public design_coef_gamma: number = 0

    public fj0coef: number = 0
    public fj0exp: number = 0
    public fjmin1ASexp: number = 0
    public fjmin1Aexp: number = 0
    public fjmin1Bexp: number = 0
    public fjmin1Cexp: number = 0
    public fjmin1AScoef: number = 0
    public fjmin1Acoef: number = 0
    public fjmin1Bcoef: number = 0
    public fjmin1Ccoef: number = 0

    public carbon_coefs_objects = new Array<CarbonCoefType>()
}

export default ShipType